// extracted by mini-css-extract-plugin
export var imageCaption = "imageCaption-module--imageCaption--cBgTl";
export var imageContainer = "imageCaption-module--imageContainer--ivKeQ";
export var image = "imageCaption-module--image--3+OG+";
export var widthNormal = "imageCaption-module--widthNormal--VIgF+";
export var widthFull = "imageCaption-module--widthFull--6V-qq";
export var creditText = "imageCaption-module--creditText--K7Ti8";
export var slideUp = "imageCaption-module--slideUp--YuH-x";
export var slideUpLarge = "imageCaption-module--slideUpLarge--kdc-I";